import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/api/constants'

import { apiDeleteSession } from './index'

export const useDeleteSession = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => apiDeleteSession(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.SESSIONS],
      })
    },
  })
}
